import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import { translate } from '@openclassrooms/translations';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import ContactChannelButton from '../ContactChannelButton';
import { ContactContext, type ContactContextType } from '../ContactProvider';
export default function ContactChannelButtonFaq() {
  const $ = _c(6);
  const {
    helpType
  } = useContext(ContactContext) as ContactContextType;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  let t0;
  if ($[0] !== getLocalisationConfig) {
    t0 = getLocalisationConfig("faq.student.url");
    $[0] = getLocalisationConfig;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = String(t0);
  const t2 = `Navigation|Redirection::External|support-panel|faq-${helpType}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = translate("support.global.contact_channel.faq.title");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <ContactChannelButton iconComponent={HelpIcon} href={t1} data-event={t2}>{t3}</ContactChannelButton>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}